import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-action-cell',
  template: `
    <span *ngIf="params.data.user === params.data.loggedInUser" title="Edit Comment">
      <mat-icon (click)="invokeEditComment()">edit</mat-icon>
    </span>
    <span title="Delete Comment">
      <mat-icon (click)="invokeDeleteComment()">delete</mat-icon>
    </span>
    <span *ngIf="params.data.hasChanges">
      <mat-icon (click)="invokeSaveComment()">save</mat-icon>
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .btn {
        line-height: 0.5;
        cursor: pointer;
      }

      .dispatched {
        color: green;
      }

      .stack-icon {
        position: absolute;
      }

      .stack-top {
        z-index: 9;
      }
    `,
  ],
})
export class CentralTaskGridActionRendererComponent {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  invokeDeleteComment() {
    this.params.context.componentParent.deleteComment(this.params.data);
  }

  invokeEditComment() {
    this.params.context.componentParent.editTaskComment(this.params.node.rowIndex, 'text');
  }

  invokeSaveComment() {
    this.params.context.componentParent.saveComment(this.params.data);
  }
}
